import { memo, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAccount } from 'src/stores';
import { EAccountType, IBaseProps } from 'src/types';
import { IRoute, Routes } from './route';

function RouteGuard({ children }: IBaseProps) {
  const { account } = useAccount();
  const { pathname } = useLocation();

  const passed = useMemo<boolean>(() => {
    if (!account) return false;

    if (account.type !== EAccountType.ROOT) {
      // @ts-ignore
      const route: IRoute = Routes[Object.keys(Routes).find((key: string) => Routes[key].path === pathname)];

      if (route.isRoot) {
        return false;
      }
    }

    return true;
  }, [account, pathname]);

  if (!account) return <Navigate to={Routes.LOGIN.path as string} />;

  if (!passed) return <Navigate to={Routes.PAGE403.path as string} />;

  return children;
}

export default memo(RouteGuard);
